import { getAppType } from './env'
import { setSocket } from '@/helpers/SocketService'
import store from '@/store/index.js'
import i18n from '@/i18n'
import { setLocale } from '@/helpers/date'

/**
 * Commits region to the Vuex store based on application type
 * @returns
 */
export const initRegion = () => {
	if (getAppType() == 'wekita') {
		return store.commit('setRegion', 'wekita')
	}
	const currentRegion = store.getters.getRegion()
	if (!currentRegion) {
		const fallbackRegion = i18n.locale == 'de' ? 'de' : 'pl'
		store.commit('setRegion', fallbackRegion)
	}
}

export default class Langugage {
	constructor(vue) {
		this.vue = vue
	}
	/**
	 * Sets application language
	 * @param locale Language abbreviation
	 */
	selectLanguage(locale) {
		const language = locale ? locale : 'pl'
		this.vue.$i18n.locale = language
		setLocale(this.vue.$i18n.locale)
		this.vue.$store.commit('setSelectedLanguage', '')
		if (setSocket) setSocket(this.vue)
	}
	/**
	 * Gets locale based on given region
	 * @returns Locale / language abbreviation
	 */
	getLangFromRegion = (region) => {
		switch (region) {
			case 'pl':
				return 'pl'
			case 'de':
			case 'ch':
				return 'de'
			case 'na':
				return 'en'
		}
	}
	/**
	 * Sets initial application language based on browser's settings
	 */
	async setupInitLanguage() {
		const browserLanguages = navigator.languages.join('-')
		const browserLanguage = browserLanguages.includes('pl')
			? 'pl'
			: browserLanguages.includes('de')
			? 'de'
			: 'en'
		const user = this.vue.$store.getters.currentRole
		const jwt = user && user.jwt ? user.jwt : null
		const selectedLanguage = this.vue.$store.state.selectedLanguage
		const userLanguage = jwt ? await this.fetchLanguage() : undefined
		const queryLang = new URLSearchParams(window.location.search).get(
			'lang',
		)

		switch (true) {
			case user.type == 'support':
				this.vue.$i18n.locale = 'en'
				break
			case queryLang != undefined &&
				languageOptions.map((l) => l.key).includes(queryLang):
				this.vue.$i18n.locale = queryLang
				// this.vue.$query.removeQuery('lang')
				break
			case userLanguage != undefined:
				this.vue.$i18n.locale = userLanguage
				break
			case selectedLanguage != '':
				this.vue.$i18n.locale = selectedLanguage
				break
			default:
				this.vue.$i18n.locale = browserLanguage
		}
		setLocale(this.vue.$i18n.locale)
		document.documentElement.lang = this.vue.$i18n.locale
		initRegion()
	}
	initRegion = () => initRegion()
	/**
	 * Gets language based on the account
	 *
	 * @returns
	 */
	fetchLanguage = () => {
		return this.vue.$api
			.get('v1/accounts')
			.then(({ data }) => {
				return data.language
			})
			.catch(() => {
				return undefined
			})
	}
}

export const regionOptions = [
	{
		key: 'pl',
		display: 'POLAND',
		icon: 'assets/img/flags/poland.svg',
	},
	{
		key: 'de',
		display: 'GERMANY',
		icon: 'assets/img/flags/germany.svg',
	},
	{
		key: 'ch',
		display: 'SWITZERLAND',
		icon: 'assets/img/flags/switzerland.svg',
		fake: true,
	},
	{
		key: 'ac',
		display: 'AUSTRIA',
		icon: 'assets/img/flags/austria.svg',
	},
	{
		key: 'es',
		display: 'SPAIN',
		icon: 'assets/img/flags/spain.svg',
	},
	{
		key: 'ua',
		display: 'UKRAINE',
		icon: 'assets/img/flags/ukraine.svg',
	},
	{
		key: 'mx',
		display: 'MEXICO',
		icon: 'assets/img/flags/mexico.webp',
	},
	{
		key: 'sa',
		display: 'SOUTH_AMERICA',
		icon: 'assets/img/flags/sa.png',
	},
]

export const languageOptions = [
	{
		value: 'pl',
		key: 'pl',
		display: 'LABEL_POLISH',
		icon: 'assets/img/flags/poland.svg',
	},
	{
		value: 'en',
		key: 'en',
		display: 'LABEL_ENGLISH',
		icon: 'assets/img/flags/united-kingdom.svg',
	},
	{
		value: 'de',
		key: 'de',
		display: 'GERMAN',
		icon: 'assets/img/flags/germany.svg',
	},
	{
		value: 'es',
		key: 'es',
		display: 'SPANISH',
		icon: 'assets/img/flags/spain.svg',
	},
	{
		value: 'mx',
		key: 'mx',
		display: 'MEXICAN',
		icon: 'assets/img/flags/mexico.webp',
	},
	{
		value: 'ca',
		key: 'ca',
		display: 'CATALONIAN',
		icon: 'assets/img/flags/catalonia.svg',
	},
	{
		value: 'ua',
		key: 'ua',
		display: 'UKRAINIAN',
		icon: 'assets/img/flags/ukraine.svg',
	},
	{
		value: 'gl',
		key: 'gl',
		display: 'GALICIAN',
		icon: 'assets/img/flags/flag_galicia.png',
	},
	{
		value: 'eu',
		key: 'eu',
		display: 'BASQUE',
		icon: 'assets/img/flags/flag_basque.png',
	},
	{
		value: 'val',
		key: 'val',
		display: 'VALENCIAN',
		icon: 'assets/img/flags/flag_valencian.png',
	},
]
